var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemMultipleChoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 6h7a1 1 0 0 1 0 2h-7a1 1 0 1 1 0-2m-3 12h10a1 1 0 0 1 0 2H10a1 1 0 1 1 0-2m3-6h7a1 1 0 0 1 0 2h-7a1 1 0 1 1 0-2m-1.753-2.664a1 1 0 0 1-.083 1.411l-4.5 4a1 1 0 0 1-1.371-.04l-2-2a1 1 0 1 1 1.414-1.414l1.333 1.332 3.796-3.372a1 1 0 0 1 1.411.083m0-6a1 1 0 0 1-.083 1.411l-4.5 4a1 1 0 0 1-1.371-.04l-2-2a1 1 0 1 1 1.414-1.414L6.04 6.625l3.796-3.372a1 1 0 0 1 1.411.083M6 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
})));
export default SvgGemMultipleChoice;